



























import { Vue, Component } from 'vue-property-decorator';

@Component
export default class CookieConsent extends Vue {
    show = true;

    approveCookieConsent() {
        this.show = false;
        this.$emit('cookie-approved', true);
    }

}
